import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';
import { isAxiosError } from 'axios';

import { PROJECTS_EXPERIMENTS_QUERY_KEY } from '@/entities/experiment/model/useProjectsExperiments';
import { projectApi } from '@/entities/project/api/projectApi';
import type { ProjectDetail, UpdateProjectRequest } from '@/entities/project/domain/types';

import { PROJECT_QUERY_KEY } from './useProject';

type UpdateProjectParams = {
  projectId: number;
  data: UpdateProjectRequest;
};

export const useUpdateProject = () => {
  const queryClient = useQueryClient();

  return useMutation<ProjectDetail, Error, UpdateProjectParams>({
    mutationFn: ({ projectId, data }: UpdateProjectParams) => projectApi.update(projectId, data),
    onSuccess: (_, variables) => {
      void queryClient.invalidateQueries({ queryKey: [PROJECT_QUERY_KEY, variables.projectId] });
      void queryClient.invalidateQueries({ queryKey: [PROJECTS_EXPERIMENTS_QUERY_KEY] });
      message.success('프로젝트가 수정되었습니다');
    },
    onError: (error: Error) => {
      const errorMessage =
        isAxiosError(error) && error.response?.data?.message
          ? error.response.data.message
          : '프로젝트 수정에 실패했습니다';

      message.error(errorMessage);
    },
  });
};
